import { useState } from 'react'
import siteContent from '../../content/siteContent'
import './Contact.css'

export default function Contact() {
  const content = siteContent.contact
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    inquiryType: content.form.inquiryOptions[0],
    message: ''
  })
  const [submitted, setSubmitted] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/functions/v1/api/feedback`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-admin-secret": process.env.REACT_APP_MARKET_SECRET, 
          },
          body: JSON.stringify({
            name: formData.fullName,
            email: formData.email,
            inquiryType: formData.inquiryType,
            message: formData.message,
          }),
        }
      );

      const data = await res.json();

      if (!res.ok) throw new Error(data.error || "Failed to send");

      setSubmitted(true);

      setTimeout(() => {
        setFormData({
          fullName: "",
          email: "",
          inquiryType: content.form.inquiryOptions[0],
          message: "",
        });
        setSubmitted(false);
      }, 3000);
    } catch (err) {
      console.error("Error submitting form:", err);
      alert("Something went wrong. Please try again later.");
    }
  };


  return (
    <div className="contact-page">
      {/* Header Section */}
      <section className="contact-header-section">
        <div className="container">
          <span className="contact-label">{content.label}</span>
          <h1>
            {content.heading}
            <br />
            <span className="highlight">{content.highlightedHeading}</span>
          </h1>
          <p className="contact-intro">{content.intro}</p>
        </div>
      </section>

      {/* Form & Contact Details Section */}
      <section className="contact-form-section">
        <div className="container">
          <div className="contact-grid">
            {/* Form */}
            <div className="contact-form-area">
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label>{content.form.labels.fullName}</label>
                  <input
                    type="text"
                    name="fullName"
                    placeholder={content.form.placeholders.fullName}
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>{content.form.labels.email}</label>
                  <input
                    type="email"
                    name="email"
                    placeholder={content.form.placeholders.email}
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>{content.form.labels.inquiryType}</label>
                  <select
                    name="inquiryType"
                    value={formData.inquiryType}
                    onChange={handleChange}
                  >
                    {content.form.inquiryOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>{content.form.labels.message}</label>
                  <textarea
                    name="message"
                    placeholder={content.form.placeholders.message}
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                {submitted && (
                  <div className="success-message">
                    {content.form.successMessage}
                  </div>
                )}

                <button
                  type="submit"
                  className="btn2-primary"
                  style={{ width: '100%', marginBottom: 0 }}
                >
                  {content.form.submitButton}
                </button>
              </form>
            </div>

            {/* Contact Details */}
            <div className="contact-details-area">
              <div className="direct-channels-card">
                <h3>{content.directChannels.heading}</h3>
                <p>{content.directChannels.intro}</p>

                <div className="channels-list">
                  {content.directChannels.channels.map((channel, idx) => (
                    <div key={idx} className="channel-item">
                      <div className="channel-icon">{channel.icon}</div>
                      <div className="channel-content">
                        <span className="channel-label">{channel.label}</span>
                        <p className="channel-title">{channel.title}</p>
                        <p className="channel-details">{channel.details}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     
    </div>
  )
}
